import { render, staticRenderFns } from "./zbhd.vue?vue&type=template&id=7d588ff6&"
import script from "./zbhd.vue?vue&type=script&lang=js&"
export * from "./zbhd.vue?vue&type=script&lang=js&"
import style0 from "./zbhd.vue?vue&type=style&index=0&id=7d588ff6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports